<template>
	<div
		v-if="show"
		class="d-flex align-center justify-center"
		:class="{ 'fixed': !adsoluted, 'absolute': adsoluted }"
		style="
			left: 0;
			right: 0;
			top: 0;
			bottom: 0;
			backdrop-filter: blur(4px);
			background-color: rgba(255, 255, 255, 0.1);
			z-index: 100;
		">
		<v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
	</div>
</template>
<script>
export default {
	props: {
		show: {
			type: Boolean,
			default: false,
		},
		adsoluted: {
			type: Boolean,
			default: false,
		}
	},
};
</script>
